import { Component, ViewChild, TemplateRef, Input, ElementRef, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AuService } from '../au.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-au-followups',
  templateUrl: './au-followups.component.html',
  styleUrls: ['./au-followups.component.scss']
})

export class AuFollowupsComponent implements OnInit, OnChanges, OnDestroy {
  infoIconSrc: string = 'src/assets/img/info-yellow.png';
  isProcessing = true;
  @Input() activityData: boolean;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  makeStickyColumns: any;
  auFollowupsDataForGrid: any = [];
  auFollowupsDataForGridTemp: any = [];
  columnLists: any = {};
  dataTypeList: any = [];
  listOfResponsibilityUser: any = [];
  listOfFindingsValueFromQmsAuFindingsVw: any = [];
  searchText: any;
  searchValue: any;
  showingRowsText = "Showing rows";
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  dateCustomClasses: DatepickerDateCustomClasses[];
  dropDownForStatus: any;
  statusDropdown: any;
  findingTxt: any;
  responsibilityUseTxt: any;
  statusTxt: any;
  selectedAssignedToDepartment: any = null;
  isFindingOdd = null;
  isResponsibilityUserOdd = null;
  isStatusOdd = null;
  qmsAuFollowupsFieldData: any = {};
  editorValue: any;
  assignedToDepartmentTxt: any;
  departmentCodeDropdown: any = [];
  isassignedToDepartmentOdd: any = null;
  dropDownForDepartmentCode: any = [];
  textareaEditorTitle: string = '';
  config: EditorConfig = { buttons: [] };
  config1: EditorConfig = { buttons: ST_BUTTONS };

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    private readonly elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService, public auService: AuService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };
  showFollowupAddBtn: boolean = false;

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    if ((this.qmsservice.activity.status == 'Received Q&A Response' || this.qmsservice.activity.status == 'In Progress/Received Q&A Response'
      || this.qmsservice.activity.status == 'In Progress' || this.qmsservice.activity.status == 'Peer Review Rejected'
      || this.qmsservice.activity.status == 'Peer Reviewer Requested More Info.' || this.qmsservice.activity.status == 'Findings In Progress'
      || this.qmsservice.activity.status == 'Pending Implementation Review' || this.qmsservice.activity.status == 'Implementation Review Rejected'
      || this.qmsservice.activity.status == 'Pending Implementation Verification' || this.qmsservice.activity.status == 'Implementation Verification Rejected'
      || this.qmsservice.activity.status == 'Closed/Finding In Progress' || this.qmsservice.activity.status == 'Pending Auditee Review'
      || this.qmsservice.activity.status == 'Auditee Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Approver Requested More Info.' || this.qmsservice.activity.status == 'Closure Reviewer Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Review Rejected' || this.qmsservice.activity.status == 'Closure Approval Rejected') && this.auService.isAuditor) {
      this.showFollowupAddBtn = true;
    } else {
      this.showFollowupAddBtn = false;
    }

    this.appService.getAuParticipantsByAuNo(this.qmsservice.activityId).subscribe({
      next: (data: any) => {
        this.listOfResponsibilityUser = data;
        this.selectBoxForResponsibilityUserList();
      },
      error: (error) => {
        this.isProcessing = false;
      }
    });

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxForDepartmentCode();
    this.appService.getCodeListsByGroup("FINDINGS_FOLLOWUP_STATUS").subscribe({
      next: (data: any) => {
        this.dropDownForStatus = data;
        this.selectBoxForStatus();
      },
      error: (error) => {
        this.isProcessing = false;
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  ngOnChanges() {
    if (this.activityData) {
      this.getcallMethod();
    } else {
      this.labelcall();
      this.openEditPopup(this.message.taskLevelData, 'EDIT');
    }
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData1(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error) => {
        console.log(error);
      }
    });
    this.isProcessing = false;
  }

  selectBoxForStatus() {
    this.statusDropdown = this.dropDownForStatus?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "AU_FOLLOWUPS",
      groupId: 0
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_AU_FOLLOWUPS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          auNoFromAu: this.message.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {

            this.auFollowupsDataForGrid = response1;
            this.visibleAuditTrail = false;

            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {

                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }

                for (const row of this.auFollowupsDataForGrid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      row[element.columnName] = row[element.columnName] == "Y";
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.labelcall();
                this.setPage(1, 0);

              }
            });

            this.message.gridList = this.auFollowupsDataForGrid;
            this.collectionSize = this.auFollowupsDataForGrid.length;
            this.totalPages = Math.ceil(this.auFollowupsDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;

          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;

      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    this.isProcessing = true;
    let data = {
      gridName: this.reportObj.gridName ? this.reportObj.gridName : 'AU_FOLLOWUPS',
      tableName: this.reportObj.tableOrViewName ? this.reportObj.tableOrViewName : 'QMS_AU_FOLLOWUPS_VW',
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auFollowupsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auFollowupsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auFollowupsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auFollowupsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auFollowupsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.auFollowupsDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.auFollowupsDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.auFollowupsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.auFollowupsDataForGridTemp = this.auFollowupsDataForGrid;
      this.pager = this.paginationService.getPager(this.auFollowupsDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.auFollowupsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.auFollowupsDataForGrid == undefined) {
        return this.auFollowupsDataForGrid;
      }
      if (!this.auFollowupsDataForGrid.length) {
        return this.auFollowupsDataForGrid;
      }
      if (filter) {
        this.auFollowupsDataForGridTemp = this.auFollowupsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.auFollowupsDataForGridTemp = this.auFollowupsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.auFollowupsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.auFollowupsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.auFollowupsDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.FOLLOWUP_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.auFollowupsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '0px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
  }

  selectedFinding: any = null;
  findingDropdown: any = [];
  selectedResponsibilityUser: any = null;
  responsibilityUserDropdown: any = [];
  selectedStatus: any = null;
  selectBoxForFindings() {
    this.findingDropdown = [];
    for (const element of this.listOfFindingsValueFromQmsAuFindingsVw) {
      this.findingDropdown = this.findingDropdown.concat({
        valueExp: element.findingId,
        displayExp: element.findingShortDescription.trim()
      });
    }
  }

  selectBoxForResponsibilityUserList() {
    this.responsibilityUserDropdown = [];
    for (const element of this.listOfResponsibilityUser) {
      if (element.applicationUserId != null && element.isParticipantUserActive == "Y") {
        this.responsibilityUserDropdown = this.responsibilityUserDropdown.concat({
          valueExp: element.applicationUserId,
          displayExp: element.userName
        });
      }
    }
  }

  onFindingSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item.valueExp != undefined) {
          this.findingFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  onFindingRemoved(item: any) {
    this.findingFieldValue = document.getElementById('department-validation') as HTMLInputElement;
    if (this.findingFieldValue != undefined) {
      this.findingFieldValue.style.color = 'red';
    }
  };

  onResponsibilityUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item.valueExp != undefined) {
          this.responsibilityUserFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  onResponsibilityUserRemoved(item: any) {
    this.responsibilityUserFieldValue = document.getElementById('responsibilityUser-validation') as HTMLInputElement;
    if (this.responsibilityUserFieldValue != undefined) {
      this.responsibilityUserFieldValue.style.color = 'red';
    }
  };

  onChangeOfDueDateDate(items: any) {
    this.dueDateFieldValue = document.getElementById('dueDate-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.dueDateFieldValue.style.color = '#005c8a';
    } else {
      this.dueDateFieldValue.style.color = 'red';
    }
  }

  onChangeOfCompletedOnDate(items: any) { }

  popupTitle: any;
  visibleEditButton: boolean;
  operationFlag: any;
  openAddPopup() {
    this.isProcessing = true;
    this.isFindingOdd = null;
    this.isResponsibilityUserOdd = null;
    this.isStatusOdd = null;
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Audit Followups";
    this.visibleEditButton = true;
    this.qmsAuFollowupsFieldData.dueDate = null;
    this.qmsAuFollowupsFieldData.completedOn = null;
    this.qmsAuFollowupsFieldData.assignedToUserDetails = '';
    this.qmsAuFollowupsFieldData.responsesPending = '';
    this.qmsAuFollowupsFieldData.comments = '';
    this.selectedAssignedToDepartment = null;
    this.isassignedToDepartmentOdd = null;
    this.qmsAuFollowupsFieldData = {
      assignedToUserDetails: '',
      responsesPending: '',
      comments: '',
    };
    this.selectedFinding = null;
    this.selectedResponsibilityUser = null;
    this.qmsAuFollowupsFieldData.isApplicationUser = false;
    this.selectedStatus = null;
    this.appService.getAllAuFindingsByAuNo(this.message.activityId).subscribe((data: any) => {
      this.listOfFindingsValueFromQmsAuFindingsVw = data;
      this.selectBoxForFindings();

      this.appService.getAuParticipantsByAuNo(this.message.activityId).subscribe((data: any) => {
        this.listOfResponsibilityUser = data;
        this.selectBoxForResponsibilityUserList();
        this.isProcessing = false;
      });

    });

    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);

  }

  editingFollowupId: any;
  objForDocuments: any;

  openEditPopup(auFollowupsEditingData: any, mode: any) {
    if (this.visibleAddAndEditPopup?.getState() === 0) {
      return;
    }
    this.selectedStatus = [];
    this.isProcessing = true;

    if (mode == "VIEW") {
      this.operationFlag = 'VIEW';
    } else {
      this.operationFlag = 'EDIT';
    }

    this.popupTitle = "Update Audit Followups";
    this.visibleEditButton = false;
    this.editingFollowupId = auFollowupsEditingData.FOLLOWUP_ID;
    this.auService.followUpId = auFollowupsEditingData.FOLLOWUP_ID;

    this.objForDocuments = {
      id: auFollowupsEditingData.FOLLOWUP_ID,
      pagename: "Audit FollowUp"
    };

    this.appService.getAuFollowupByFollowupId(
      this.editingFollowupId
    ).subscribe((data: any) => {

      if (data) {
        data.dueDate = data.dueDate ? new Date(data.dueDate) : null;
        data.isApplicationUser = data.isApplicationUser == "Y";

        if (data.status) {
          const filteredstatusValue = this.statusDropdown.find((item: any) => item.valueExp == data.status);
          if (filteredstatusValue) {
            this.isStatusOdd = null;
            this.selectedStatus = filteredstatusValue.valueExp;
          } else {
            this.statusDropdown.push({
              valueExp: data.status,
              displayExp: data.status
            });
            this.isStatusOdd = this.selectedStatus = data.status;
          }
        }

        this.qmsAuFollowupsFieldData = data;

        this.appService.getAllAuFindingsByAuNo(
          auFollowupsEditingData.AU_NO
        ).subscribe((data: any) => {
          this.listOfFindingsValueFromQmsAuFindingsVw = data;
          this.selectBoxForFindings();

          if (this.qmsAuFollowupsFieldData.findingId) {
            const filteredFindingsValue = this.findingDropdown.find((item: any) => item.valueExp == this.qmsAuFollowupsFieldData.findingId);
            if (filteredFindingsValue) {
              this.isFindingOdd = null;
              this.selectedFinding = filteredFindingsValue.valueExp;
            } else {
              this.findingDropdown.push({
                valueExp: this.qmsAuFollowupsFieldData.findingId,
                displayExp: this.qmsAuFollowupsFieldData.findingId
              });
              this.isFindingOdd = this.selectedFinding = this.qmsAuFollowupsFieldData.findingId;
            }
          }
        });

        this.appService.getAuParticipantsByAuNo(
          auFollowupsEditingData.AU_NO
        ).subscribe((data: any) => {
          this.listOfResponsibilityUser = data;
          this.selectBoxForResponsibilityUserList();

          if (this.qmsAuFollowupsFieldData.assignedToUser) {
            const filteredResponsibilityUserValue = this.responsibilityUserDropdown.find(
              (item: any) => item.valueExp == this.qmsAuFollowupsFieldData.assignedToUser
            );

            if (filteredResponsibilityUserValue) {
              this.isResponsibilityUserOdd = null;
              this.selectedResponsibilityUser = filteredResponsibilityUserValue.valueExp;
            } else {
              const user = this.listOfResponsibilityUser.find(
                (item: any) => item.applicationUserId == this.qmsAuFollowupsFieldData.assignedToUser
              );
              this.responsibilityUserDropdown.push({
                valueExp: this.qmsAuFollowupsFieldData.assignedToUser,
                displayExp: user?.userName || 'Unknown User'
              });
              this.isResponsibilityUserOdd = this.selectedResponsibilityUser = this.qmsAuFollowupsFieldData.assignedToUser;
            }
          }
        });

        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      } else {
        this.isProcessing = false;
      }
    });
  }


  deletingFollowupId: any;
  openDeletePopup(auFollowupsEditingData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Audit Followups";
    this.deletingFollowupId = auFollowupsEditingData.FOLLOWUP_ID;
    this.qmsAuFollowupsFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  findingFieldValue: any;
  responsibilityUserFieldValue: any;
  dueDateFieldValue: any;
  fieldValidation() {
    this.findingFieldValue = document.getElementById('finding-validation') as HTMLInputElement;
    this.responsibilityUserFieldValue = document.getElementById('responsibilityUser-validation') as HTMLInputElement;
    this.dueDateFieldValue = document.getElementById('dueDate-validation') as HTMLInputElement;

    if (this.selectedFinding == null) {
      this.findingFieldValue.style.color = 'red';
    } else {
      this.findingFieldValue.style.color = '#005c8a';
    }

    if (this.selectedResponsibilityUser == null) {
      this.responsibilityUserFieldValue.style.color = 'red';
    } else {
      this.responsibilityUserFieldValue.style.color = '#005c8a';
    }

    if (this.qmsAuFollowupsFieldData.dueDate == null || this.qmsAuFollowupsFieldData.dueDate == '' || this.qmsAuFollowupsFieldData.dueDate == undefined) {
      this.dueDateFieldValue.style.color = 'red';
    } else {
      this.dueDateFieldValue.style.color = '#005c8a';
    }
  }

  onFieldFocusout() {
    if (this.deleteReasonfieldValidation != undefined) {
      if (this.qmsAuFollowupsFieldData.deleteReason == "" || this.qmsAuFollowupsFieldData.deleteReason == undefined) {
        this.deleteReasonfieldValidation.style.color = 'red';
      } else {
        this.deleteReasonfieldValidation.style.color = '#005c8a';
      }
    }
  }

  addAndEditFunction(qmsAuFollowupsFieldData: any) {
    this.isProcessing = true;
    if (this.selectedFinding == null || this.selectedResponsibilityUser == null || this.qmsAuFollowupsFieldData.dueDate == null) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      if (qmsAuFollowupsFieldData.dueDate) {
        const dueDateValue = new Date(qmsAuFollowupsFieldData.dueDate);
        qmsAuFollowupsFieldData.dueDate = this.appService.dateZoneConvertion(dueDateValue);
      } else {
        qmsAuFollowupsFieldData.dueDate = null;
      }
      const data = {
        auNo: this.message.activityId,
        findingId: this.selectedFinding ?? null,
        dueDate: qmsAuFollowupsFieldData.dueDate,
        assignedToUser: this.selectedResponsibilityUser ?? null,
        assignedToUserDetails: qmsAuFollowupsFieldData.assignedToUserDetails,
        responsesPending: qmsAuFollowupsFieldData.responsesPending,
        isApplicationUser: qmsAuFollowupsFieldData.isApplicationUser ? "Y" : "N",
        assignedToDepartment: this.selectedAssignedToDepartment ?? null,
        comments: qmsAuFollowupsFieldData.comments,
        status: this.selectedStatus ?? null,
        seq: qmsAuFollowupsFieldData.seq
      }



      if (this.operationFlag == 'ADD') {
        this.appService.createQmsAuFollowup(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.refreshGridData()
      } else {
        delete qmsAuFollowupsFieldData.createdOn;
        delete qmsAuFollowupsFieldData.updatedOn;

        const modifiedData = {
          ...data,
          followupId: this.editingFollowupId,
          completedOn: qmsAuFollowupsFieldData.completedOn ? new Date(qmsAuFollowupsFieldData.completedOn) : null,
        }

        this.appService.updateQmsAuFollowup(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {

              if (this.auService.auditPageFrom != "MyTask") {
                this.ngOnInit();
              } else if (!this.activityData) {
                this.message.taskLevelData.subModuleName = '';
                this.message.taskLevelData.subModuleName = '';
              }
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
    if (!this.activityData) {
      this.message.taskLevelData.subModuleName = '';
      this.message.taskLevelData.subModuleName = '';
    }
  }

  deleteReasonfieldValidation: any;
  deleteFunction(qmsAuFollowupsFieldData: any) {
    if (this.qmsAuFollowupsFieldData.deleteReason) {
      this.isProcessing = true;
      const data = {
        followupId: this.deletingFollowupId,
        deleteReason: qmsAuFollowupsFieldData.deleteReason,
        auNo: this.message.activityId,
      }
      this.appService.deleteQmsAuFollowup(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            if (this.auService.auditPageFrom != "MyTask") {
              this.ngOnInit();
            }
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.deleteReasonfieldValidation = document.getElementById('delete-reason-validation') as HTMLInputElement;
      this.deleteReasonfieldValidation.style.color = 'red';
      alert('Please enter the all mandatory fields...');
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, followUp: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : followUp.FOLLOWUP_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'AU_FOLLOWUPS';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Followups Audit Trail [' + this.qmsservice.activity.auId + ']';
    this.dynamicAuditTrailComponent.triggerTrail(followUp);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Followups Report [' + this.qmsservice.activity.auId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  public openEditor(value: string, icon: string): void {
    const editorTitleMapping: Record<string, any> = {
      'Assigned To User Details': this.dynamicLabel?.['ASSIGNED_TO_USER_DETAILS'],
      'Responses Pending': this.dynamicLabel?.['RESPONSES_PENDING'],
      'Comments': this.dynamicLabel?.['COMMENTS'],
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName].fieldName;
    this.editorValue = this.qmsAuFollowupsFieldData[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qmsAuFollowupsFieldData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  selectBoxForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  focusEmpty(): void {
    console.log();
  }
}
